<template>
  <CCard>
    <CCardHeader>
      <div class="card-title">
        {{ $t("role.role.tab_wallet.card_wallet.title") }}
      </div>
    </CCardHeader>
    <CCardBody>
      <div class="bd-example">
        <dl class="row">
          <dd class="col-sm-2">
            {{ $t("models.family_wallet.iban") }}
          </dd>
          <dt class="col-sm-10">
            <CInput
              v-if="dataForm.active"
              :description="$t('models.family_wallet.iban_info')"
              horizontal
              v-model="dataForm.body.iban"
              :is-valid="'iban' in dataForm.errors ? false : null"
              :invalid-feedback="
                'iban' in dataForm.errors
                  ? dataForm.errors.iban.join('<br>')
                  : null
              "
            />
          </dt>

          <dd class="col-sm-2">
            {{ $t("models.family_wallet.bic") }}
          </dd>
          <dt class="col-sm-10">
            <CInput
              v-if="dataForm.active"
              :description="$t('models.family_wallet.bic_info')"
              horizontal
              v-model="dataForm.body.bic"
              :is-valid="'bic' in dataForm.errors ? false : null"
              :invalid-feedback="
                'bic' in dataForm.errors
                  ? dataForm.errors.bic.join('<br>')
                  : null
              "
            />
          </dt>

          <!-- <dd class="col-sm-2">
            {{ $t("models.family_wallet.pay_freq") }}
          </dd>
          <dt class="col-sm-4">
            <span>{{
              GetFtype(dataForm.body.pay_freq)
            }}</span>
            <CSelect
              v-if="dataForm.active"
              :description="$t('models.family_wallet.pay_freq_info')"
              horizontal
              :is-valid="'pay_freq' in dataForm.errors ? false : null"
              :invalid-feedback="
                'pay_freq' in dataForm.errors
                  ? dataForm.errors.pay_freq.join('<br>')
                  : null
              "
              :value.sync="dataForm.body.pay_freq"
              :options="options"
            />
          </dt>

          <dd class="col-sm-2">
            {{ $t("models.family_wallet.wallet_min") }}
          </dd>
          <dt class="col-sm-4">
            <span>{{ dataForm.body.wallet_min }}</span>
            <CInput
              v-if="dataForm.active"
              :description="$t('models.family_wallet.wallet_min_info')"
              horizontal
              v-model="dataForm.body.wallet_min"
              :is-valid="'wallet_min' in dataForm.errors ? false : null"
              :invalid-feedback="
                'wallet_min' in dataForm.errors
                  ? dataForm.errors.wallet_min.join('<br>')
                  : null
              "
            />
          </dt> -->
        </dl>
      </div>
    </CCardBody>
    <CCardFooter v-if="dataForm.active">
      <vue-ladda
        :loading="dataForm.loading"
        data-style="zoom-in"
        button-class="btn btn-primary"
        @click.prevent="SaveData"
        >{{ $t("common.editor.button.save") }}</vue-ladda
      >
    </CCardFooter>
  </CCard>
</template>

<script>
import { apiPatch } from "../../../helpers/apiHelper";

export default {
  name: "RoleWallet",
  props: ["wl"],
  data() {
    return {
      dataForm: {
        loading: false,
        active: true,
        body: {
          id: "",
          iban: "",
          bic: "",
          pay_freq: "",
          wallet_min: "",
        },
        errors: {},
      },
      options: [
        {
          value: "2",
          label: this.$t("models.family_wallet.pay_freq_option2"),
        },
      ],
    };
  },
  mounted() {
    this.dataForm.body.id = this.wl.id;
    this.dataForm.body.iban = this.wl.iban;
    this.dataForm.body.bic = this.wl.bic;
    this.dataForm.body.pay_freq = this.wl.pay_freq;
    this.dataForm.body.wallet_min = this.wl.wallet_min;
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
  },
  methods: {
    GetFtype(ftype) {
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value == ftype) {
          return this.options[i].label;
        }
      }
      return ftype;
    },
    async SaveData() {
      this.dataForm.loading = true;
      this.dataForm.errors = {};

      const response = await apiPatch(
        "auth_fwallet",
        this.dataForm.body.id,
        this.dataForm.body,
        [this.$store.state.role.family_id]
      );

      if (response && response.status === 200) {
        this.dataForm.loading = false;
        this.$store.dispatch("toaster/add", {
          title: this.$t("user.profile.data.ok.title"),
          text: this.$t("user.profile.data.ok.message"),
          color: "success",
          autohide: true,
        });
      } else if (response && response.errors) {
        this.dataForm.errors = response.errors;
        this.loading = false;
      } else {
        this.dataForm.loading = false;
        Object.entries(response).forEach(([key, value]) => {
          this.$store.dispatch("toaster/add", {
            title: this.$t("common.general.savingError"),
            text: `${value}`,
            color: "danger",
            autohide: true,
          });
        });
        this.dataForm.loading = false;
      }
    },
  },
};
</script>
